<template>
    <div class="wout-login">
        <div class="center">
            <div>
                <img src="@/assets/img/pronto.svg" 
                    width="auto" height="130" alt="Agora, deixe sua chave na recepção!" crossorigin />
            </div>
            <span class="pronto">Pronto!</span>
            <span class="pronto">Agora, deixe sua chave na recepção!</span>
        </div>
    </div>
</template>
<script>

export default {
    data: () => {
        return {
            
        }
    }
}
</script>

<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
}
.pronto {
    font-weight: normal;
    color: white!important;
    padding: 5px;
    width: 60vw;
    text-align: center;
}
</style>